var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.25 3.625C16.207 3.625 17 4.41797 17 5.375V14.125C17 15.1094 16.207 15.875 15.25 15.875H4.75C3.76562 15.875 3 15.1094 3 14.125V5.375C3 4.41797 3.76562 3.625 4.75 3.625H15.25ZM6.0625 14.5625V12.1562H4.3125V14.125C4.3125 14.3711 4.50391 14.5625 4.75 14.5625H6.0625ZM6.0625 10.8438V8.65625H4.3125V10.8438H6.0625ZM6.0625 7.34375V4.9375H4.75C4.50391 4.9375 4.3125 5.15625 4.3125 5.375V7.34375H6.0625ZM12.625 14.5625V10.4062H7.375V14.5625H12.625ZM12.625 9.09375V4.9375H7.375V9.09375H12.625ZM15.6875 14.125V12.1562H13.9375V14.5625H15.25C15.4688 14.5625 15.6875 14.3711 15.6875 14.125ZM15.6875 10.8438V8.65625H13.9375V10.8438H15.6875ZM15.6875 7.34375V5.375C15.6875 5.15625 15.4688 4.9375 15.25 4.9375H13.9375V7.34375H15.6875Z",
    fill: "#1D2132",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.144724f680ce175f2822f8fff0b0f790.svg";
export { ForwardRef as ReactComponent };